import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { isLogoutAction } from '../auth';

import { CallData } from './types';

const initialState: CallData = {
  getPetIDs: [],
  isOnCall: false,
  isChatEnded: false,
  isOnVideoCall: false,
  activeVideoCall: null,
  isOutboundCall: false,
  isVideoCallEnded: false,
};

export const callSlice = createSlice({
  initialState,
  name: 'callSlice',
  extraReducers: (builder) => {
    builder.addMatcher(isLogoutAction, (state) => {
      Object.entries(initialState).forEach((item) => {
        const [key, value] = item;
        // @ts-ignore
        state[key] = value;
      });
    });
  },
  reducers: {
    setOnCall: (state, { payload }: PayloadAction<boolean>) => {
      state.isOnCall = payload;
    },
    setChatEnded: (state, { payload }: PayloadAction<boolean>) => {
      state.isChatEnded = payload;
    },
    setOnVideoCall: (state, { payload }: PayloadAction<boolean>) => {
      state.isOnVideoCall = payload;
    },
    setGetPetIDs: (state, { payload }: PayloadAction<Array<number>>) => {
      state.getPetIDs = payload;
    },
    setActiveVideoCall: (state, { payload }: PayloadAction<any>) => {
      state.activeVideoCall = payload;
    },
    setOutboundCall: (state, { payload }: PayloadAction<boolean>) => {
      state.isOutboundCall = payload;
    },
    setVideoCallEnded: (state, { payload }: PayloadAction<boolean>) => {
      state.isVideoCallEnded = payload;
    },
  },
});

const {
  reducer: callReducer,
  actions: {
    setOnCall,
    setChatEnded,
    setGetPetIDs,
    setOnVideoCall,
    setOutboundCall,
    setVideoCallEnded,
    setActiveVideoCall,
  },
} = callSlice;

const callStore = (store: RootState) => store?.call;

export const selectIsOnCall = () =>
  createSelector([callStore], (store) => store?.isOnCall ?? false);

export const selectIsOutboundCall = () =>
  createSelector([callStore], (store) => store?.isOutboundCall ?? false);

export {
  setOnCall,
  callReducer,
  setGetPetIDs,
  setChatEnded,
  setOnVideoCall,
  setOutboundCall,
  setVideoCallEnded,
  setActiveVideoCall,
};
